// Not for hooks — this keeps the theme object on the client side of the RSC
// boundary. createTheme() output carries functions (spacing, breakpoints.up,
// styleOverrides callbacks), which cannot be passed to a client component.
'use client'

import type { JSX } from 'react'
import CssBaseline from '@mui/material/CssBaseline'
import { ThemeProvider as MuiThemeProvider } from '@mui/material/styles'
import { theme } from './theme'

export function ThemeProvider({ children }: { children }): JSX.Element {
  return (
    <MuiThemeProvider theme={theme}>
      <CssBaseline />
      {children}
    </MuiThemeProvider>
  )
}
